import { useEffect, useState } from "react";
import { Table } from "reactstrap";
import { Pageable } from "../../../../types/common";
import { Action } from "../../../../types/reducer-action";
import { IMemo } from "../../../../types/user";
import { DataEntryEvent } from "../../../common/data-entry-reducer";
import DateFormat from "../../../common/date-format";
import PaginationBar from "../../../common/pagination-bar";
import TableHeaders, { TableHeaderInfo } from "../../../common/table-header";
import TableRow from "../../../common/table-row";
import { UserManagerDomain, useUserDispatch, useUserState } from "../user-manager-context";

const TABLE_HEADERS: TableHeaderInfo<IMemo>[] = [
  { header: 'Memo', accessor: 'memoTxt', sortable: true },
  { header: 'Created By', accessor: 'createUser', sortable: true, cssClass: "email-column" },
  { header: 'Created Date', accessor: 'createTimestamp', presorted: 'desc', cssClass: "date-column date-column-iso" }
];

const UserMemosTable = (props: Pageable) => {
  const { pageSize } = props;

  const { subdomains } = useUserState();
  const dispatch = useUserDispatch();

  const { [UserManagerDomain.Memos]: memoState } = subdomains;

  const { dataSet, selectedDataId } = memoState ?? {};

  const [sortedData, setSortedData] = useState<IMemo[]>([]);
  const [pagedData, setPagedData] = useState<IMemo[]>([]);

  const selectItem = (item?: IMemo) => {
    dispatch(new Action(UserManagerDomain.Memos + DataEntryEvent.SelectData, item?.id));
    dispatch(new Action(UserManagerDomain.Memos + DataEntryEvent.SetDataDetails, item));
  }

  useEffect(() => {
    selectItem(pagedData.find(item => item.id === selectedDataId))
  }, [pagedData, selectedDataId]);

  return (
    <section aria-label="User memos">
      <Table striped hover id="user-memos" className="fixed">
        <TableHeaders headers={TABLE_HEADERS} sortableData={dataSet} onSort={setSortedData} />

        {dataSet && dataSet.length > 0
          ?
          <tbody>
            {pagedData.map((item) =>
              <TableRow key={item.id}
                selected={item.id === selectedDataId} onSelect={() => selectItem(item)}>
                <td className="text-truncate memo-text-col">{item.memoTxt}</td>
                <td title={item.createUserInfo && item.createUser}>
                  {item.createUserInfo
                    ? `${item.createUserInfo.firstName} ${item.createUserInfo.lastName}`
                    : item.createUser
                  }
                </td>
                <td><DateFormat date={item.createTimestamp} format="YYYY-MM-DD" /></td>
              </TableRow>
            )}
          </tbody>
          :
          <tfoot>
            <tr>
              <td colSpan={TABLE_HEADERS.length} className="text-center">
                Create a new memo to see it here.
              </td>
            </tr>
          </tfoot>
        }
      </Table>

      <PaginationBar data={sortedData} pageSize={pageSize} onPageChange={setPagedData} />
    </section>
  );
};

export default UserMemosTable;
